import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { GET_USERS, GET_ACCOUNT_INFO, CREATE_CUSTOMER, GET_SUBSCRIPTIONS, GET_DASHBOARD, ADD_DASHBOARD_ITEM, DELETE_DASHBOARD_ITEM } from "./actionTypes"
import { fetchUsersSuccess, fetchUsersError, createCustomerSuccess, createCustomerFailuer,
  getSubscriptionsSuccess, getSubscriptionsError, getAccountInfoSuccess, getAccountInfoError, getDashboardSuccess, getDashboardError, addDashboardItemSuccess, addDashboardItemError, deleteDashboardItemSuccess, deleteDashboardItemError } from "./actions"

//Include Both Helper File with needed methods
import {
  getUsers,
  getAccountInfo,
  getSubscriptions,
  getDashboard,
  createStripeCustomer,
  postProfile,
  addDashboardItem,
  deleteDashboardItem
} from "../../helpers/fakebackend_helper"

function* fetchUsers() {
  try {
     const users = yield call(getUsers)
     console.log(users)
     yield put(fetchUsersSuccess(users))
  } catch (error) {
     yield put(fetchUsersError(error))
  }
}

function* fetchAccountInfo({ payload: customer_id }) {
  try {
     console.log(customer_id)
     console.log("ASDFASDFASDF")
     const session = yield call (getAccountInfo, customer_id)
     console.log(session)
     yield put(getAccountInfoSuccess(session))
  } catch (error) {
     yield put(getAccountInfoError(error))
  }
}

function *fetchSubscriptions({}) {
  try {
     const subscriptions = yield call (getSubscriptions)
     console.log(subscriptions)
     yield put(getSubscriptionsSuccess(subscriptions))
  } catch (error) {
     yield put(getSubscriptionsError(error))
  }
}

function* fetchDashboard() {
  try {
     const dashboard = yield call(getDashboard)
     console.log(dashboard)
     yield put(getDashboardSuccess(dashboard))
  } catch (error) {
     yield put(getDashboardError(error))
  }
}

function* saveDashboardItem ({ payload: item }) {
  try {
    console.log(item)
    const response = yield call(addDashboardItem, item)
    yield put(addDashboardItemSuccess(response))
  } catch (error) {
    yield put(addDashboardItemError(error))
  }
}

function* removeDashboardItem({ payload: id }) {
  try { 
    console.log(id)
    const response = yield call(deleteDashboardItem, id)
    yield put(deleteDashboardItemSuccess(response))
  } catch (error) {
    yield put(deleteDashboardItemError(error))
  }
}

function* saveNewCustomer ({ payload: profile }) {
  try {
    console.log(profile)
    const customerId = yield call(createStripeCustomer, profile)
    console.log(customerId)
    profile.customer_id = customerId
    const response = yield call(postProfile, profile)
    yield put(createCustomerSuccess(response))
  } catch (error) {
    yield put(addDashboardItemError(error))
  }
}

export function* watchUsers() {
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(GET_ACCOUNT_INFO, fetchAccountInfo)
  yield takeEvery(GET_SUBSCRIPTIONS, fetchSubscriptions)
  yield takeEvery(GET_DASHBOARD, fetchDashboard)
  yield takeEvery(ADD_DASHBOARD_ITEM, saveDashboardItem)
  yield takeEvery(DELETE_DASHBOARD_ITEM, removeDashboardItem)
  yield takeEvery(CREATE_CUSTOMER, saveNewCustomer)
}

function* AdminSaga() {
  yield all([fork(watchUsers)])
}

export default AdminSaga
